import {useContext, useEffect} from "react";
import {observer} from "mobx-react";
import type {BookingWizardSlideComponent} from "./types";
import {useQuery} from "@tanstack/react-query";
import {trpc} from "@/app/trpc";
import {Loader, SelectButton, YStack} from "@chayka/ui";
import {BookingStateContext} from "../state";

export const SuperTypeSlide: BookingWizardSlideComponent = observer(({setNextDisabled}) => {
  const {superType, setSuperType, setSubType, queryRoomId} = useContext(BookingStateContext);
  const {data, isFetching} = useQuery(
    trpc.booking.superTypes.queryOptions({roomId: queryRoomId || undefined}),
  );

  useEffect(() => {
    const nextSuperType =
      data?.find((item) => item.code === superType?.code && !item.disabled) ||
      data?.find((item) => !item.disabled) ||
      null;

    setSuperType(nextSuperType);

    if (nextSuperType?.code !== superType?.code) {
      setSubType(null);
    }
  }, [data, setSubType, setSuperType, superType?.code]);
  useEffect(() => setNextDisabled(!superType), [superType, setNextDisabled]);

  if (isFetching) {
    return (
      <div className="w-full h-full flex justify-center items-center">
        <Loader />
      </div>
    );
  }

  return (
    <YStack className="w-full gap-3">
      {data?.map((st) => (
        <SelectButton
          key={st.code}
          className="w-full"
          selected={st.code === superType?.code}
          disabled={st.disabled}
          onClick={() => {
            setSuperType(st);
            setSubType(null);
          }}
        >
          {st.name}
        </SelectButton>
      ))}
    </YStack>
  );
});
